define('MultiAddToCart.Button.View', [
    'MultiAddToCart.Confirmation.View',
    'multi_add_to_cart_button.tpl',

    'Backbone',
    'underscore'
], function (
    MultiAddToCartConfirmationView,
    multi_add_to_cart_button_tpl,

    Backbone,
    _
) {
    'use strict';

    return Backbone.View.extend({
        template: multi_add_to_cart_button_tpl,

        events: {
            'click [data-action="multi-add-to-cart"]': 'multiAddToCart'
        },

        multiAddToCart: function multiAddToCart() {
            var self = this;
            var container = this.options.container;
            var cart = container.getComponent('Cart');
            var lines = this.getLines();
            self.environment = this.options.container.getComponent('Environment');

            if (cart && lines.length) {
                cart.addLines({ lines: lines }).done(function afterAddToCart(cartData) {
                    var layout = container.getComponent('Layout');
                    var confirmationView = new MultiAddToCartConfirmationView({
                        itemCount: lines.reduce(function sum(subtotal, line) {
                            return subtotal + Number(line.quantity);
                        }, 0)
                    });

                    // Reset items to be added into the cart
                    self.removeLines();
                    // Re-render item list
                    try {
                        // window.location.reload();
                        container.getLayout().getCurrentView().render();
                    } catch (e) {
                        console.log('multiAddToCart', e);
                    }

                    confirmationView.modalClass = 'added-to-cart-modal';

                    // Show confirmation modal
                    layout.showContent(confirmationView, {
                        showInModal: true
                    });
                });
            }

        },

        render: _(Backbone.View.prototype.render).wrap(function render(fn) {
            var _this = this;
            var args = arguments;
            var userProfile = _this.options.container.getComponent('UserProfile');

            userProfile.getUserProfile().done(function (profile) {
                _this.userProfile = profile;
            }).always(function () {
                fn.apply(_this, _(args).toArray().slice(1));
            });
        }),

        disableButton: function () {
            //We've got to disable loginToSeePrices feature if customer registration is disabled.
            var _this = this;
            var configuration = _this.options.container.getComponent('Environment');
            var plp = _this.options.container.getComponent('PLP');
            //use below if login is required and Login required for Pricing 
            // return _this.getRegistrationType !== 'disabled' && configuration.getSiteSetting('requireloginforpricing') === 'T' && _this.userProfile.isloggedin === true && plp.getDisplay().id === 'multi-add-to-cart';
            return _this.getRegistrationType !== 'disabled' && plp.getDisplay().id === 'multi-add-to-cart';
        },

        getLines: function getLines() {
            this.lines = SC.SESSION ? SC.SESSION.multiAddToCart || {} : {};

            this.lines = _(this.lines).reject(function eachLine(line) {
                return Number(line.quantity) === 0;
            });
            return this.lines;
        },

        removeLines: function removeLines() {
            if (SC.SESSION) {
                SC.SESSION.multiAddToCart = this.lines = {};
            }
        },

        getContext: function getContext() {
            var _this = this;
            var lines = _this.getLines();
            var plp = _this.options.container.getComponent('PLP');
            return {
                isButtonEnabled: _this.disableButton(),
                lines: lines,
                itemCount: lines.reduce(function sum(subtotal, line) {
                    return subtotal + Number(line.quantity);
                }, 0)
            };
        }
    });
});
